module.exports = __webpack_public_path__ + "static/media/map_icon_medical_center.77230c03.svg";